import { useState } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Services from './components/Services';
import Trust from './components/Trust';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import CTASection from './components/CTASection';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Benefits />
      <Services />
      <Trust />
      <Testimonials />
      <Gallery />
      <CTASection />
      <WhatsAppButton />
    </div>
  );
}
